/** 登录白卡片表单（字号、间距、尺寸在此调节，单位 px） */
export const LoginFormConfig = {
  /** 表单整体宽度 */
  widthPx: 440,
  /** 表单内边距：上 / 左右 */
  paddingTopPx: 20,
  paddingHorizontalPx: 30,
  /** 「登录/注册」按钮下方留白（表单 padding-bottom） */
  submitButtonBottomGapPx: 0,
  /** 标题行：LOGO 尺寸、与标题间距、标题行与下方提示间距 */
  titleLogoSizePx: 36,
  titleRowGapPx: 10,
  titleRowMarginBottomPx: 20,
  /** 标题行（LOGO + 主标题）水平对齐：left | center | right */
  titleRowAlign: 'center' as 'left' | 'center' | 'right',
  /** 主标题字号 */
  titleFontSizePx: 18,
  /** 「未注册的手机号…」提示字号、与下方表单间距 */
  tipFontSizePx: 12,
  tipMarginBottomPx: 8,
  /** 表单项之间的垂直间距 */
  formItemMarginBottomPx: 17,
  /** 输入框高度 */
  inputHeightPx: 40,
  /** 登录按钮高度、字号 */
  submitButtonHeightPx: 40,
  submitButtonFontSizePx: 14,
  /** 协议勾选区域字号 */
  agreementFontSizePx: 11,
} as const
